import { defineMessages } from 'react-intl';

export const messages: {
	benefitsSectionButtonMaybeLater: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionButtonTryItFree: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingHelpCenterCustomization: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionHeadingIncidentsSlackIntegration: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionLinkPricing: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	benefitsSectionSubtitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	buttonTriggerOpenModal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	buttonTriggerTryItFree: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	benefitsSectionButtonMaybeLater: {
		id: '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later',
		defaultMessage: 'Maybe later',
		description:
			'Button in the edition benefits modal that allows the user to dismiss the upgrade prompt and return to it later.',
	},
	benefitsSectionButtonTryItFree: {
		id: '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free',
		defaultMessage: 'Try it free',
		description:
			'Primary call-to-action button in the edition benefits modal that initiates a free trial of Premium features.',
	},
	benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1',
		defaultMessage:
			'<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
		description: 'Text for first feature in help-center-customization variant',
	},
	benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2',
		defaultMessage: '<strong>Customise your help center</strong> to match your brand.',
		description: 'Text for second feature in help-center-customization variant',
	},
	benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3',
		defaultMessage:
			'<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
		description: 'Text for third feature in help-center-customization variant',
	},
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1',
		defaultMessage:
			'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
		description: 'Text for first feature in incidents-slack-integration variant',
	},
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2',
		defaultMessage:
			'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
		description: 'Text for second feature in incidents-slack-integration variant',
	},
	benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
		id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3',
		defaultMessage:
			'<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
		description: 'Text for third feature in incidents-slack-integration variant',
	},
	benefitsSectionHeadingHelpCenterCustomization: {
		id: '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization',
		defaultMessage: 'Try advanced Help Center customisation with Premium',
		description: 'Heading for help-center-customization variant',
	},
	benefitsSectionHeadingIncidentsSlackIntegration: {
		id: '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration',
		defaultMessage: 'Resolve incidents with AI in Slack, try Premium now',
		description: 'Heading for incidents-slack-integration variant',
	},
	benefitsSectionLinkPricing: {
		id: '@atlassian/edition-benefits-modal.benefits-section.link.pricing',
		defaultMessage: 'See more Premium features and pricing',
		description:
			'Link in the edition benefits modal that navigates the user to a page listing Premium features and their pricing.',
	},
	benefitsSectionSubtitle: {
		id: '@atlassian/edition-benefits-modal.benefits-section.subtitle',
		defaultMessage:
			"Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
		description:
			'Subtitle displayed in the benefits section of the edition benefits modal, explaining the free trial offer for Premium features.',
	},
	buttonTriggerOpenModal: {
		id: '@atlassian/edition-benefits-modal.button-trigger.open-modal',
		defaultMessage: 'Open modal',
		description: 'Text for the button that opens the edition benefits modal',
	},
	buttonTriggerTryItFree: {
		id: '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free',
		defaultMessage: 'Try it free',
		description: 'Button text for to trigger opening the premium benefits modal',
	},
});
